// The phase review's card in the thread (spec §13.5 step 5; M6.4): a
// plan_update with body.kind 'phase_review' {text, phase, next, decision},
// written at the end of a phase's last week. Says what the coach decided for
// the next phase and opens the race screen's timeline. A rework ('replace')
// arrives later as the strategy check's proposal; the card says so.
import React from 'react';
import { Button } from '../ds';
import { phaseReviewView } from '../../v2/season';
import { CardActions, CardTitle, CoachCard, Eyebrow, WhyLink } from './coachCard';

export default function PhaseReviewCard({ item, onOpenTimeline, onWhy }) {
  const v = phaseReviewView(item);
  const phase = item?.body?.phase;
  return (
    <CoachCard role="article" aria-label={`Plan update: ${v.title}`} data-decision={v.decision}>
      <Eyebrow>{phase ? `Phase review · ${phase}` : 'Phase review'}</Eyebrow>
      <CardTitle>{v.title}</CardTitle>
      {v.text && <p className="m-0 type-body-small text-text-body">{v.text}</p>}
      {v.reworkFollows && (
        <p className="m-0 type-caption text-text-tertiary">Your coach will propose the reworked phase here for you to accept.</p>
      )}
      {(onOpenTimeline || onWhy) && (
        <CardActions>
          {onOpenTimeline && <Button size="small" kind="text" className="px-1" onClick={() => onOpenTimeline(item)}>Open timeline</Button>}
          {onWhy && <WhyLink onClick={() => onWhy(item)} />}
        </CardActions>
      )}
    </CoachCard>
  );
}
